module.exports = __webpack_public_path__ + "img/harvest_stop_btn.4accbb79.svg";